import Message from '@/components/MassagesBox/install'

/**
 * 判断当前返回的参数是 blob, ArrayBuffer, Json
 */
const checkPass = (data) => {
  return (
    data instanceof Blob ||
    data instanceof ArrayBuffer ||
    (data && data.code && data.code === '10000')
  )
}

export const interceptor = {
  /**
   * @description: 响应拦截器处理
   */
  responseInterceptors: (response) => {
    const { data: res } = response

    if (!checkPass(res)) {
      Message.install({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(response)
    } else {
      return response
    }
  },

  /**
   * @description: 请求错误处理
   */
  requestInterceptorsCatch: (error) => {
    return Promise.reject(error)
  },

  /**
   * @description: 响应错误处理
   */
  responseInterceptorsCatch: (error) => {
    const status = (error.response && error.response.status) || 400

    let message = ''

    switch (status) {
      case 400:
        message = '请求错误'
        break
      case 401:
        message = '未授权，请登录'
        break
      case 403:
        message = '拒绝访问'
        break
      case 404:
        message = `请求地址出错: ${error.response.config.url}`
        break
      case 408:
        message = '请求超时'
        break
      case 500:
        message = '服务器内部错误'
        break
      case 501:
        message = '服务未实现'
        break
      case 502:
        message = '网关错误'
        break
      case 503:
        message = '服务不可用'
        break
      case 504:
        message = '网关超时'
        break
      case 505:
        message = 'HTTP版本不受支持'
        break
      default:
        break
    }

    Message.install({
      message,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  }
}
